import React from 'react';
import loadable from '@loadable/component';
import Loader from 'yoda-core-components/lib/components/Loader/Loader';

export default loadable(
    () =>
        import(
            /* webpackChunkName: "LazyMarketplaceChunk", webpackPreload: true */ './MarketplaceReturnWebview'
        ),
    {
        fallback: (
            <div className="loading-wrapper">
                <Loader keepOverlay loaderClass="lazy-loader" />
            </div>
        ),
    }
);
